import { useCallback, useEffect, useRef } from 'react';
import { useFormLoadObserver } from './useFormLoadObserver';
import { useFormThemeStyles } from './useFormThemeStyles';
import { getFormsDomain, injectScript } from './formScript';
import { jsx as _jsx } from "react/jsx-runtime";
export function VersionTwoForm({
  formId,
  portalId,
  env,
  region,
  dispatch
}) {
  const containerRef = useRef(null);
  const themeStyles = useFormThemeStyles();
  useEffect(() => {
    injectScript(`//js.${getFormsDomain(env)}/forms/embed/developer/${portalId}.js`);
  }, [portalId, env]);
  const handleReady = useCallback(() => dispatch('onFormReady'), [dispatch]);
  useFormLoadObserver(containerRef, handleReady, [formId, portalId, env, handleReady]);
  useEffect(() => {
    const handleSubmitted = e => {
      const detail = e.detail;
      if (detail.formId === formId) {
        dispatch('onFormSubmitted');
      }
    };
    window.addEventListener('hs-form-event:on-submission:success', handleSubmitted);
    return () => window.removeEventListener('hs-form-event:on-submission:success', handleSubmitted);
  }, [formId, dispatch]);
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    className: "hs-form-html",
    style: themeStyles,
    "data-form-id": formId,
    "data-portal-id": portalId,
    "data-region": region,
    "data-env": env
  });
}